export default __webpack_public_path__ + "static/media/icon-exclamation-circle.264f2f72.svg";